(function () {
  var nav = document.querySelector('[data-cellfy-nav]');
  if (!nav) return;

  var items = Array.prototype.slice.call(nav.querySelectorAll('[data-cellfy-nav-item]'));

  function focusableIn(el) {
    return Array.prototype.slice.call(
      el.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  // The "open" item is whichever one CSS is currently showing the panel
  // for (:hover, :focus-within, or a leftover [data-open]) — there is no
  // JS-tracked state to get out of sync with what's actually on screen.
  function currentOpenItem() {
    return items.find(function (item) {
      return (
        item.matches(':hover') ||
        item.matches(':focus-within') ||
        item.hasAttribute('data-open')
      );
    });
  }

  items.forEach(function (item) {
    var trigger = item.querySelector('[data-cellfy-nav-trigger]');
    var panel = item.querySelector('[data-cellfy-panel]');
    if (!trigger || !panel) return;

    // Keep aria-expanded in sync for screen readers, driven by the same
    // pure-CSS state (no timers, nothing to race).
    function syncAria() {
      var isOpen =
        item.matches(':hover') || item.matches(':focus-within') || item.hasAttribute('data-open');
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    }
    item.addEventListener('pointerenter', syncAria);
    item.addEventListener('pointerleave', function () {
      // Once the pointer genuinely leaves, lift any Esc-suppression so the
      // panel is free to open again next time.
      item.removeAttribute('data-suppressed');
      syncAria();
    });
    item.addEventListener('focusin', syncAria);
    item.addEventListener('focusout', syncAria);
  });

  // The backdrop should only dim the page BELOW the header (announcement
  // bar + nav row), never the header itself. Header height isn't a fixed
  // constant (announcement bar collapses on scroll, sticky header, etc.),
  // so track it live instead of hardcoding a number.
  var backdrop = document.querySelector('[data-cellfy-backdrop]');
  var header = document.querySelector('[data-cellfy-header]');
  if (backdrop && header) {
    var updateBackdropTop = function () {
      backdrop.style.top = header.getBoundingClientRect().bottom + 'px';
    };
    updateBackdropTop();
    window.addEventListener('scroll', updateBackdropTop, { passive: true });
    window.addEventListener('resize', updateBackdropTop);
  }

  // Esc closes the currently open panel and returns focus to its trigger.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var item = currentOpenItem();
    if (!item) return;
    var trigger = item.querySelector('[data-cellfy-nav-trigger]');
    item.setAttribute('data-suppressed', '');
    item.removeAttribute('data-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.focus();
    }
  });

  // Basic focus trap: while a panel is open, Tab cycles between the
  // trigger link and the focusable elements inside the panel.
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var item = currentOpenItem();
    if (!item) return;
    var trigger = item.querySelector('[data-cellfy-nav-trigger]');
    var panel = item.querySelector('[data-cellfy-panel]');
    var focusables = [trigger].concat(focusableIn(panel));
    if (!focusables.length) return;

    var first = focusables[0];
    var last = focusables[focusables.length - 1];
    var active = document.activeElement;

    if (e.shiftKey && active === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && active === last) {
      e.preventDefault();
      first.focus();
    }
  });
})();